import type {
  ProductSubproductToolConfig,
  ToolScanSchedulerConfig,
} from "types/api/alertTypes";
import { PageResponse } from "types/pageResponse";

import { makeCancellableAPIRequest } from "./index";

const ToolScanSchedulerAPI = {
  postToolScanFrequency(data: ToolScanSchedulerConfig) {
    return makeCancellableAPIRequest<ToolScanSchedulerConfig>(
      "POST",
      "user/tools/scheduler",
      {
        data,
      },
    );
  },
  updateToolScanFrequency(data: ToolScanSchedulerConfig, id: string) {
    return makeCancellableAPIRequest<ToolScanSchedulerConfig>(
      "PUT",
      `user/tools/scheduler/${id}`,
      {
        data,
      },
    );
  },
  getToolScanFrequency(toolName: string) {
    return makeCancellableAPIRequest<ToolScanSchedulerConfig>(
      "GET",
      `user/tools/scheduler/default/${toolName}`,
    );
  },
  getproductSubproductToolConfig(toolName: string) {
    return makeCancellableAPIRequest<PageResponse<ProductSubproductToolConfig>>(
      "GET",
      `user/tools/scheduler/${toolName}`,
    );
  },
  deleteProductSubproductToolConfig(id: string) {
    return makeCancellableAPIRequest("DELETE", `/user/tools/scheduler/${id}`);
  },
};

export default ToolScanSchedulerAPI;
